import { createSlice } from '@reduxjs/toolkit';
import { updateAuthInformation } from './auth-slice';
import { AsyncStatus } from '@algoan/dashboard/model';

export interface ActivityPageReducerState {
  refreshInProgress: AsyncStatus;
}

const getInitialState = (): ActivityPageReducerState => ({
  refreshInProgress: AsyncStatus.IDLE,
});

const initialState = getInitialState();

const activityPageSlice = createSlice({
  name: 'activityPage',
  initialState,
  reducers: {
    refreshActivityStart: (state) => {
      state.refreshInProgress = AsyncStatus.PENDING;
    },
    refreshActivityFinish: (state) => {
      state.refreshInProgress = AsyncStatus.IDLE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(updateAuthInformation, (state, action) => {
      if (typeof action.payload === 'undefined') {
        // we clear the state on logout
        return getInitialState();
      }

      return state;
    });
  },
});

export const { reducer: activityPageReducer } = activityPageSlice;
export const { refreshActivityStart, refreshActivityFinish } = activityPageSlice.actions;
